import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import ContactView from '@/views/ContactView.vue'
import MessageView from '@/views/MessageView.vue'
import NewsletterView from '@/views/NewsletterView.vue'
import AbbonnementView from '@/views/AbbonnementView.vue'
import BlogView from '@/views/BlogView.vue'
import BlogDetailView from '@/views/BlogDetailView.vue' // nouvelle page
import CustomView from '@/views/CustomView.vue'
import LegalView from '@/views/LegalView.vue'
import DashboardView from '@/views/DashboardView.vue'
import BillingView from '@/views/BillingView.vue'
import BillingEdit from '@/views/BillingEdit.vue'
import MarketingView from '@/components/MarketingView.vue'
import TicketView from '@/views/TicketView.vue'
import ProjectView from '@/views/ProjectsView.vue'
import ProjectsNew from '@/views/ProjectsNew.vue'
import SettingsView from '@/views/SettingsView.vue'
import FactureView from '@/views/FactureView.vue'
const routes = [
  { path: '/login', name: 'login', component: LoginPage },
    { path: '/login/reset/:token', name: 'login-reset', component: LoginPage, props: true }, // ← route pour reset
  { path: '/contact', name: 'contact', component: ContactView },
  { path: '/maintenance', name: 'maintenance', component: AbbonnementView },
  { path: '/newsletter', name: 'newsletter', component: NewsletterView },
  { path: '/messages', name: 'messages', component: MessageView },
  { path: '/blog', name: 'blog', component: BlogView },
  { path: '/custom', name: 'custom', component: CustomView },
   { path: '/legal', name: 'legal', component: LegalView },
  { path: '/', name: 'dashboard', component: DashboardView },
  { path: '/billing', name: 'billing', component: BillingView },
   { path: '/billing/:id', name: 'billing-edit', component: BillingEdit },
    { path: '/marketing', name: 'marketing', component: MarketingView },
    { path: '/tickets', name: 'tickets', component: TicketView },
     { path: '/projects', name: 'projects', component: ProjectView },
      { path: '/projects/:id', name: 'projects/:id', component: ProjectsNew },
        { path: '/settings', name: 'settings', component: SettingsView },
        { path: '/factures', name: 'factures', component: FactureView },
  
  // route dynamique pour créer ou modifier un blog
  { path: '/blog/:id', name: 'blog-detail', component: BlogDetailView, props: true },

  { path: '/a-propos', name: 'a propos', component: () => import('../views/AboutView.vue') },
  { path: '/404', name: '404', component: () => import('../components/PageError.vue') },
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// ✅ Protection des routes
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/login/reset/:token'] // ajouter la route reset
  const authRequired = !publicPages.some(path => {
    // match dynamique pour les routes avec param
    const regex = new RegExp('^' + path.replace(':token', '[^/]+') + '$')
    return regex.test(to.path)
  })
  
  const token = localStorage.getItem('token')

  if (authRequired && !token) {
    return next('/login')
  }

  next()
})


export default router
